<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>服务成果库</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <el-input
            placeholder="请输入内容"
            v-model="listQuery.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <!--<el-button @click="downFn" type="primary">下载模板</el-button>
          <el-button type="success" @click="exportFn">导入</el-button>
          <el-button @click="deleteAll" type="danger">批量删除</el-button>-->
        </div>
        <div class="base-result">
          <div class="result-item">
            <p>服务企业及团队(家)</p>
            <p>{{ titleInfo.serviceNumTotal || 0 }}</p>
          </div>
          <div class="result-item">
            <p>服务合同金额(万元)</p>
            <p>{{ titleInfo.serviceContractTotal || 0 }}</p>
          </div>
          <div class="result-item">
            <p>创新券金额(万元)</p>
            <p>{{ titleInfo.couponTotal || 0 }}</p>
          </div>
          <div class="result-item">
            <p>服务成果(份)</p>
            <p>{{ titleInfo.servicAchievementTotal || 0 }}</p>
          </div>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column label="仪器/服务名称" align="center" prop="instrumentName"></el-table-column>
            <el-table-column label="机构名称" align="center" prop="serviceOrgName"></el-table-column>
            <el-table-column label="服务企业及团队" align="center" prop="serviceNumTotal"></el-table-column>
            <el-table-column
              label="服务合同金额(万元)"
              align="center"
              prop="serviceFeeTotal"
            ></el-table-column>
            <el-table-column
              label="创新劵金额(万元)"
              align="center"
              prop="innovationCouponUsed"
            ></el-table-column>
            <el-table-column
              label="服务成果(份)"
              align="center"
              prop="approvalStatus"
            ></el-table-column>
            <el-table-column label="年度" align="center" prop="orgName"></el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next,jumper"
          :total="total"
          :current-page.sync="listQuery.page"
          style="text-align:left;margin:20px 0"
          :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from '../../../components/common-layout.vue';
import { FunDownload, ExportFn } from '@/utils/tool';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      Title: '',
      // 1待审核, 2不通过, 3退回, 4通过
      approvalStatus: '',
      formApprovalStatus: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      titleInfo: {},
      serviceTypeList: [
        {
          label: '检测检验',
          id: 1
        },
        {
          label: '委托开发',
          id: 2
        },
        {
          label: '专利申请代理',
          id: 3
        },
        {
          label: '技术转移',
          id: 4
        }
      ],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogType: '',
      dialogImageUrl: '',
      logoSrc: [],
      realImageSrc: [],

      is_edit: false,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      orgTypeList: [],
      investmentList: [],
      number: 0,
      operationType: 'add',
      per_page: 10,
      total: 0,
      tableData: [],
      limit: 1,
      deleteRow: null
    };
  },
  computed: {
    isDetail() {
      return this.dialogType === 'detail' && this.formApprovalStatus === 4;
    }
  },
  created() {
    this.getData();
    this.getGroup();
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logoSrc: {
      handler() {
        this.checkLimit(this.logoSrc, 0);
      }
    },
    realImageSrc: {
      handler() {
        this.checkLimit(this.realImageSrc, 1);
      }
    }
  },
  methods: {
    //   下载
    downFn() {
      FunDownload(
        this.imgUrl + 'lanzhoufile/65645ce0d302e__!c2182834ff4d48c394801a662c1aab6c300234944940308323.xlsx',
        '科技项目库.xlsx'
      );
    },
    async exportFn() {
      let res = await ExportFn(
        `${this.urlConfig.devUrl}apij2/admin-api/finance/finance-manager/import-excel`
      );
      if (res.code === 0) {
        this.$message.success(`数据导入成功`);
        this.search();
      } else {
        this.$message.warning(`数据导入失败`);
      }
    },
    selectionChange(selection) {
      this.deleteRow = selection;
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.http
              .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/finance-manager/delBatch`, {
                dels: this.deleteRow
              })
              .then(res => {
                if (res.code == 0) {
                  this.search();
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  });
                } else {
                  this.$message({
                    message: '失败！',
                    type: 'error'
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的记录'
        });
      }
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    async open() {
      if (this.dialogType === 'add') {
        this.resetData();
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        this.getDetail();
      }
    },
    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = res.data;
          this.realImageSrc = res.data.realImageSrc ? JSON.parse(res.data.realImageSrc) : [];
          this.logoSrc = res.data.logoSrc ? JSON.parse(res.data.logoSrc) : [];
        } else {
          this.resetData();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getPageCount() {
      this.http
      .post(
          this.urlConfig.devUrl + 'apij2/admin-api/innovation/instrument-apply/pageCount',
          this.listQuery
      )
      .then(res => {
        if (res.code === 0) {
          this.titleInfo = res.data;
        }
      });
    },
    getData() {
      this.getPageCount()
      if (this.listQuery.approvalStatus === null) {
        this.$delete(this.listQuery, 'approvalStatus');
      }
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/innovation/instrument-apply/pageOrg',
          this.listQuery
        )
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
    },
    handleDelete(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
      .then(() => {
        let obj = {
          ids: [row.id]
        }
        this.http.delete(`${urlConfig.devUrl}apij2/admin-api/innovation/instrument-apply/delete`, obj).then(res => {
          if (res.code === 0) {
            this.resetData();
            this.getData();
            this.$message({
              type: 'success',
              message: '删除成功',
            });
          } else {
            this.$message({
              message: '失败！',
              type: 'error',
            });
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['financial_institution_category', 'financial_investment_stage']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code == 0) {
            console.log('response', response);
            this.orgTypeList = response.data.financial_institution_category;
            this.investmentList = response.data.financial_investment_stage;
            // this.ruleForm = response.data
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this['showUpload' + (index + 1)] = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this['showUpload' + (index + 1)] = false;
      }
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    // 修改按钮操作
    editOperate() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/finance/investment-firms/update`, {
              ...this.ruleForm,
              dataType: 2
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.dialogFormVisible = false;

                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    resetData() {
      this.ruleForm = {
        //1投资机构,2金融服务机构,3担保机构
        dataType: 2,
        orgName: null, // 机构名称
        orgAbbreviation: null, // 机构简称
        orgDescription: null, // 机构简介
        orgEstablishmentDate: null, // 成立时间
        orgType: null, // 机构类型id
        orgTypeName: null, // 机构类型name
        investmentStage: null, // 投资阶段id
        investmentStageName: null, // 投资阶段name
        orgProvince: null, // 通讯地址-省
        orgCity: null, // 通讯地址-市
        orgDistrict: null, // 通讯地址-区
        orgAddress: null, // 通讯地址-详细地址
        contactPerson: null, // 联系人
        contactInfo: null, // 联系方式
        logoSrc: null, // logo
        realImageSrc: null, // 实景图
        publishedFlag: 0, // 是否发布
        approvalStatus: 1
      };
    },

    //城市选择
    citySelected(e) {
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'edit';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '详情';
      this.dialogType = 'detail';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
      this.logoSrc = [];
      this.realImageSrc = [];
    },
    // 确认添加机构
    createSite() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/finance/investment-firms/create`, {
              ...this.ruleForm,
              dataType: 2
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功');
                this.dialogFormVisible = false;
                this.resetData();
                this.getData();
              } else {
                this.$message.error(res.status);
              }
            })
            .catch(err => {
              this.dialogFormVisible = false;
            });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logoSrc);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    }
  }
};
</script>
<style lang="scss">
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-result{
    margin-top: 20px;
    display: flex;
    .result-item{
      padding-left: 30px;
      font-size: 18px;
      p{
        margin: 0;
        &:nth-child(2){
          padding-top: 5px;
          color: #623aa2;
        }
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .el-select {
    width: 100%;
    margin: 0;
  }

  @include part(form) {
    margin: 30px auto;
    width: 50%;
  }

  @include component(rowItem) {
    width: 50%;
  }

  .el-form-item__content {
    text-align: left;
  }

  /deep/.upload-demo {
    border: none;
  }
}
.form-title {
  width: 100%;
  text-align: left;
  color: #623aa2;
  border-left: 5px solid #623aa2;
  border-bottom: 1px solid #623aa2;
  padding-left: 10px;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 700;
}
</style>
